<template>
    <nav class="sidebar madisonDark mj-sidemenu left visible font-anonymouse fixed top-0 left-0 w-spc8 max-w-90p bg-dark h-full" data-sidebar-id="1">
        <div class="close absolute top-0 right-0 cursor-pointer p-spc11 opacity-50 hover:opacity-100">
            <svg id="close" viewBox="0 0 30 30" class="w-spc1 h-spc1">
                <path d="M15 0c-8.3 0-15 6.7-15 15s6.7 15 15 15 15-6.7 15-15-6.7-15-15-15zm5.7 19.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3s-.5-.1-.7-.3l-4.3-4.3-4.3 4.3c-.2.2-.4.3-.7.3s-.5-.1-.7-.3c-.4-.4-.4-1 0-1.4l4.3-4.3-4.3-4.3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l4.3 4.3 4.3-4.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-4.3 4.3 4.3 4.3z"></path>
            </svg>
        </div>
        <div class="content relative p-10 overflow-x-hidden mt-spc9">
            <ul class="mainMenu" id="sidemenu">
                <div class="menuItemsMain">
                    <a href="#madisonjames" class="inline-block">
                        <h3 class="ml-5 mb-spc10 text-white opacity-100 p-0 font-normal text-size7 leading-lh2">madisonjames</h3>
                    </a>
                    <li>
                        <a class="uppercase text-gray text-xs p-0 font-anonymouse ml-5 mb-spc5 tracking-spc5 leading-10 inline-block hover:text-darkblue" href="#flywaysticks">
                            FLYAWAY STICKS
                        </a>
                    </li>
                    <li>
                        <a class="uppercase text-gray text-xs p-0 font-anonymouse ml-5 mb-spc5 tracking-spc5 leading-10 inline-block hover:text-darkblue" href="#linens">
                            LINENS
                        </a>
                    </li>
                    <li>
                        <a class="uppercase text-gray text-xs p-0 font-anonymouse ml-5 mb-spc5 tracking-spc5 leading-10 inline-block hover:text-darkblue" href="#themadjamandfields">
                            MAD JAM & FIELD
                        </a>
                    </li>
                    <li>
                        <a class="uppercase text-gray text-xs p-0 font-anonymouse ml-5 mb-spc5 tracking-spc5 leading-10 inline-block hover:text-darkblue" href="#blacksheep">
                            BLACK SHEEP
                        </a>
                    </li>
                    <li>
                        <a class="uppercase text-gray text-xs p-0 font-anonymouse ml-5 mb-spc5 tracking-spc5 leading-10 inline-block hover:text-darkblue" href="#fieldapron">
                            THE FIELD APRON
                        </a>
                    </li>
                    <li>
                        <a class="uppercase text-gray text-xs p-0 font-anonymouse ml-5 mb-spc5 tracking-spc5 leading-10 inline-block hover:text-darkblue" href="#furniture">
                            FURNITURE
                        </a>
                    </li>
                    <li>
                        <a class="uppercase text-gray text-xs p-0 font-anonymouse ml-5 mb-spc5 tracking-spc5 leading-10 inline-block hover:text-darkblue" href="#contactus">
                            CONTACT
                        </a>
                    </li>
                </div>
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "SideMenu"
    }
</script>

<style scoped>

</style>